<div class="tmp-section-item-wrapper">
    <span multilang class="tmp-section-title">{{'Anzahl Bewertungen'}}</span>
</div>

<div class="range-slider">
    <input type="range" [max]="500 - step" [min]="0" [step]="step" (touchend)="valueChange()" (mouseup)="valueChange()"
        [(ngModel)]="currentSelected" />
</div>
<div style="display: flex;align-items: center;justify-content: space-between;padding: 7px 3px;">
    <span multilang>{{currentSelected < 500 ? currentSelected : 'beliebig' }}</span>
            <span multilang>500</span>
</div>